import { Component, OnInit, OnDestroy } from '@angular/core';
import { MarketingModel } from '../../models/marketing.model';
import { MarketingService } from '../../services/marketing.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../services/api.service';

@Component({
    selector   : 'my-marketing',
    template: require('./marketing.component.html'),
    styles: [require('./marketing.component.scss')]
})

export class MarketingComponent implements OnInit, OnDestroy{

    buttons = {
        'right': [
            {'title'    : 'voir les anciennes',
                'style' : 'secondary',
                'action': 'showArchive',
                'model' : this,
                'icon'  : 'fa-undo'
            },
        ],
    };
    listModal: any = {
        'createSMS' : false
    };
    marketing: MarketingModel;
    results: any = [];
    searchDone = false;
    nbDesactivate = 0;
    showOld = false;
    oldResults = [];
    refresh: any;

    priceperSMS: number  = 0.45;
    price: string = '0.00';
    nbCharPerSMS: number = 160;
    totalPrice:string = '0.00';

    constructor(public marketingService: MarketingService, private route: ActivatedRoute, private router:Router, private apiService:ApiService) {
        this.marketing = new MarketingModel(this.marketingService);
    }

    ngOnInit(): void {
        this.route.params.subscribe(params=> {
            //dans le cas du clique sur le bouton via la recherche
            if (params['old']) {
                this.showOld = true;
                this.getOld();
                this.refresh = setInterval(() => {
                    if (this.showOld){
                        this.getOld();
                    }
                }, 5000);
                this.buttons = {
                    'right': [
                        {'title'    : 'Créer une campagne',
                            'style' : 'primary',
                            'action': 'showCampagne',
                            'model' : this,
                            'icon'  : 'fa-shopping-bag'
                        },
                    ],
                };
            } else {

            }
        });
    }

    openFile(idPdf){
        this.apiService.downloadLetter(idPdf);
    }

    ngOnDestroy(): void {
        clearInterval(this.refresh);
    }

    showCampagne(){
        this.router.navigate(['marketing']);
    }

    showArchive() {
        this.router.navigate(['marketing', 'old']);
    }

    getOld(){
        this.marketingService.getOld(this.oldResults);
    }

    search(){
        this.totalPrice = '0.00';
        this.results = [];
        if (this.marketing.currentBrand != '')
            this.addList('brand');
        if (this.marketing.currentModel != '')
            this.addList('model');
        if (this.marketing.currentCode != '')
            this.addList('code');
        this.marketingService.search(this.marketing, this.results, this);
        setTimeout(() => {
            this.searchDone = true;
        }, 200);
        this.nbDesactivate = 0;
    }

    activateDesactivate(c){
        if (c.activate){
            this.nbDesactivate++;
            c.activate = false;
        } else {
            this.nbDesactivate--;
            c.activate = true;
        }
        this.calculatePrice();
    }

    calculatePrice(){
        if (this.marketing.type == 'mobile') {
            //sms
            this.price = (Math.ceil(this.marketing.message.length / this.nbCharPerSMS) * this.priceperSMS).toFixed(2);
            this.totalPrice = ((Math.ceil(this.marketing.message.length / this.nbCharPerSMS) * this.priceperSMS) * (this.results.length - this.nbDesactivate)).toFixed(2);
        } else if (this.marketing.type == 'adress'){
            //letter
            if (this.marketing.letterSpeed) {
                //a
                this.totalPrice = (3 * (this.results.length - this.nbDesactivate)).toFixed(2);
            } else {
                //b
                this.totalPrice = (2.75 * (this.results.length - this.nbDesactivate)).toFixed(2);
            }
        }
    }

    getDate(date){
        let d = new Date(date);
        return d.getDate() + '.' + (d.getMonth() + 1) + ' ' + d.getFullYear();
    }

    addList(name:string){
        if (name == 'brand' && this.marketing.currentBrand != ''){
            this.marketing.listBrand.push(this.marketing.currentBrand);
            this.marketing.currentBrand = '';
        }
        if (name == 'model' && this.marketing.currentModel != ''){
            this.marketing.listModel.push(this.marketing.currentModel);
            this.marketing.currentModel = '';
        }
        if (name == 'code' && this.marketing.currentCode != ''){
            this.marketing.listCode.push(this.marketing.currentCode);
            this.marketing.currentCode = '';
        }
    }

    removeList(name:string, value:string){
        let index = -1;
        if (name == 'brand'){
            index = this.marketing.listBrand.indexOf(value);
            if (index !== -1) {
                this.marketing.listBrand.splice(index, 1);
            }
        }

        if (name == 'model'){
            index = this.marketing.listModel.indexOf(value);
            if (index !== -1) {
                this.marketing.listModel.splice(index, 1);
            }
        }

        if (name == 'code'){
            index = this.marketing.listCode.indexOf(value);
            if (index !== -1) {
                this.marketing.listCode.splice(index, 1);
            }
        }
    }

    openModalSMS(){
        if(this.marketing.validateSMS()){
            this.listModal.createSMS = true;
        }
    }

    openModalLetter(){
        if(this.marketing.validateLetter()){
            this.listModal.createLetter = true;
        }
    }

    createMarketingMail(){
        let customers = [];
        this.results.forEach((r) => {
            if (r.activate) {
                customers.push(r._id);
            }
        });
        if (customers.length > 0)
            this.marketingService.sendMail(this.marketing.name, customers);
    }

    downloadCSV(id){
        this.apiService.campagneCSV(id);
    }

    createMarketingSMS(){
        if (!this.marketing.validateSMS())
            return;
        let customers = [];
        this.results.forEach((r) => {
           if (r.activate) {
               customers.push(r._id);
           }
        });
        if (customers.length > 0)
            this.marketingService.sendSMS(this.marketing.name, customers, this.marketing.message);
    }

    uploadFile(event: EventTarget){
        //todo verifier la taille
        let eventObj: MSInputMethodContext = <MSInputMethodContext> event;
        let target: HTMLInputElement = <HTMLInputElement> eventObj.target;
        let files: FileList = target.files;
        this.marketing.file = files[0];
    }

    createMarketingLetter(){
        if (!this.marketing.validateLetter())
            return;
        let customers = [];
        let categorie = 'B';
        if (this.marketing.letterSpeed)
            categorie = 'A';
        this.results.forEach((r) => {
            if (r.activate) {
                customers.push(r._id);
            }
        });
        if (customers.length > 0)
            this.marketingService.sendLetter(this.marketing.name, JSON.stringify(customers), this.marketing.file, categorie);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/pages/marketing/marketing.component.ts